import { getECargoEnvironment } from './ECargoEnvironment.js';
import productionScript from '../../StaticScripts/GoogleTagManager.script.production.js?raw';
import nonProductionScript from '../../StaticScripts/GoogleTagManager.script.non-production.js?raw';

declare const window: Window & {
    dataLayer: { [key: string]: unknown }[];
};

function setupGoogleTagManagerScript(userId: string): void {
    // The user ID must be set first so that it is available when the Google Tag Manager container code is loaded.
    setGoogleTagManagerUserId(userId);

    const environment = getECargoEnvironment();
    let content = environment === 'production' ? productionScript : nonProductionScript;

    // Remove new lines and tabs to ensure that the script is hashed correctly in all supported browsers.
    content = content.trim().replace(/[\r\n\t]/g, '');
    const script = document.createElement('script');
    script.innerHTML = content;
    document.head.insertBefore(script, document.head.firstChild);
}

function setGoogleTagManagerUserId(userId: string): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ userId: userId });
}

export { setupGoogleTagManagerScript };
